import api from "../services/authService";

const appendMany = (params, key, values = []) => {
  values.filter(Boolean).forEach((value) => params.append(key, value));
};

export const fetchArticleBankEntries = async ({
  page = 1,
  pageSize = 25,
  query = "",
  conditions = [],
  elements = [],
  kinds = [],
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (query) params.set("q", query);
  appendMany(params, "condition", conditions);
  appendMany(params, "element", elements);
  appendMany(params, "kind", kinds);
  return api.get(`/article-bank/entries/?${params.toString()}`);
};

export const fetchArticleBankFacets = async () => api.get("/article-bank/facets/");

export const fetchArticleBankEntry = async (entryId) =>
  api.get(`/article-bank/entries/${entryId}/`);
